import { LessonCompletedDto } from '@peartherapeutics/hylia-api-client';
import moment from 'moment';
import React from 'react';
import { BlockMiddleTable } from '../../Widgets/Blocks';
import { VerticalScrollbar } from '../../Widgets/CustomScrollbars';
import { CellHeader, Cell, Row, Heading } from '../../Widgets/TableComponents';
import styles from './styles.module.scss';

interface IProps {
  completedLessons: LessonCompletedDto[];
}

const CompletedLessons = (props: IProps) => {
  const { completedLessons } = props;

  /**
   * Sorts lessons by date.
   * @param a A lesson
   * @param b A lesson
   * @return a number
   */
  function byDate(a: LessonCompletedDto, b: LessonCompletedDto) {
    const bTime = new Date(b.lastCompletionDate).getTime();
    const aTime = new Date(a.lastCompletionDate).getTime();
    return bTime - aTime;
  }

  return (
    <BlockMiddleTable testId="completed-lessons-block">
      <Heading>
        <Row>
          <CellHeader externalClasses={styles['heading-title']}>
            Title
          </CellHeader>
          <CellHeader>Date Completed</CellHeader>
        </Row>
      </Heading>
      <VerticalScrollbar
        listLength={completedLessons.length}
        maximumItemsToHideScrollbar={4}
      >
        {completedLessons.sort(byDate).map((lesson, key) => {
          const rowKey = `lesson-${key}`;

          return (
            <Row key={rowKey}>
              <Cell titleKey={key} externalClasses={styles['cell-title']}>
                {lesson.name}
              </Cell>
              <Cell>{moment(lesson.lastCompletionDate).format('l')}</Cell>
            </Row>
          );
        })}
      </VerticalScrollbar>
    </BlockMiddleTable>
  );
};

export default CompletedLessons;
